/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  IndexRoute,
  Route,
} from 'react-router';
import config from 'loracfg';
import Network from '../Network';
import ADRView from '../Network/coms/ADRView';
import ChannelView from '../Network/coms/ChannelView';
import ChannelPlans from '../Network/coms/ChannelView/coms/ChannelPlans';
import AddChannelPlan from '../Network/coms/ChannelView/coms/AddChannelPlan';
import ChannelPlanDetail from '../Network/coms/ChannelView/coms/ChannelPlanDetail';
import GatewayView from '../Network/coms/GatewayView';
import NodeView from '../Network/coms/NodeView';
import SignalCoverageView from '../Network/coms/SignalCoverageView';
import QualityView from '../Network/coms/QualityView';
import QualityDetail from '../Network/coms/QualityView/coms/QualityDetail';
import DeviceQualityView from '../Network/coms/QualityView/coms/DeviceQualityView';
import CapacityView from '../Network/coms/CapacityView';
import CapacityCalculationView from '../Network/coms/CapacityCalculationView';
import UnauthorizedPacketView from '../Network/coms/UnauthorizedPacketView';
import RoadTestView from '../Network/coms/RoadTestView';
import TDMView from '../Network/coms/TDMView';
import TDMDetail from '../Network/coms/TDMView/Detail';
import TDMStatis from '../Network/coms/TDMStatis';
import GatewayStatus from '../Network/coms/TDMView/GatewayStatus';
import NodeListGtw from '../Network/coms/TDMView/GatewayStatus/NodeList';
import NodeStatus from '../Network/coms/TDMView/NodeStatus';
import BatchNodes from '../Network/coms/TDMView/BatchNodes';
import BatchPairs from '../Network/coms/TDMView/BatchPairs';

let routes;
if (config.profile === 'cube') {
  routes = (
    <Route path="network" component={Network}>
      <IndexRoute component={ADRView} />
      <Route path="adr" component={ADRView} />
      <Route path="chplans" component={ChannelView}>
        <IndexRoute component={ChannelPlans} />
        <Route path="add" component={AddChannelPlan} />
        <Route path=":id" component={ChannelPlanDetail} />
      </Route>
      <Route path="tdm" component={TDMView}>
        <IndexRoute component={TDMDetail} />
        <Route path="gateway/:id" component={GatewayStatus} />
        <Route path="gateway/:id/:type" component={NodeListGtw} />
        <Route path="node/:id" component={NodeStatus} />
        <Route path="batch/nodes" component={BatchNodes} />
        <Route path="batch/pairs" component={BatchPairs} />
      </Route>
      <Route path="tdmstatis" component={TDMStatis} />
      <Route path="roadtest" component={RoadTestView} />
    </Route>
  );
} else {
  routes = (
    <Route path="network" component={Network}>
      <IndexRoute component={ADRView} />
      <Route path="adr" component={ADRView} />
      <Route path="chplans" component={ChannelView}>
        <IndexRoute component={ChannelPlans} />
        <Route path="add" component={AddChannelPlan} />
        <Route path=":id" component={ChannelPlanDetail} />
      </Route>
      <Route path="gateway" component={GatewayView} />
      <Route path="node" component={NodeView} />
      <Route path="coverage" component={SignalCoverageView} />
      <Route path="quality" component={QualityView} >
        <IndexRoute component={QualityDetail} />
        <Route path=":id" component={DeviceQualityView} />
      </Route>
      <Route path="unauthorized" component={UnauthorizedPacketView} />
      <Route path="capacity" component={CapacityView} />
      <Route path="capacitycalculation" component={CapacityCalculationView} />
      <Route path="roadtest" component={RoadTestView} />
    </Route>
  );
}

const NetworkRoutes = routes;

export default NetworkRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/NetworkRoutes.jsx